import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class OutlierService {
  environment = EnvironmentService.environment;

  // Subjects
  public outlierManagerGridActionSubject: Subject<any> = new Subject();
  public weekCommitActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setOutlierManagerGridActionSubject = (value: any) => { this.outlierManagerGridActionSubject.next(value); };
  setWeekCommitActionSubject = (value: any) => { this.weekCommitActionSubject.next(value); };

  // Observables
  getOutlierManagerGridActionSubject = () => this.outlierManagerGridActionSubject.asObservable();
  getWeekCommitActionSubject = () => this.weekCommitActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }


  GetOutlierWeeksMetadata(numberOfWeeks: any) {
    return this.http.get(`${this.environment.outlierManager}/getweekmetadatalist?numberOfWeeks=${numberOfWeeks}`)
      .pipe(map((weekList: any) => {
        return weekList;
      }));
  }

  GetOutlierWeeksData(requestBody: any) {
    return this.http.post(`${this.environment.outlierManager}/outlierlist`, requestBody)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateOutlierGrid(body: any) {
    return this.http.post(`${this.environment.outlierManager}/updategrid`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CommitWeek(body: any) {
    return this.http.post(`${this.environment.outlierManager}/addcommit`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateOutlierResetSuggested(body: any) {
    return this.http.post(`${this.environment.outlierManager}/updateoutlierresetsuggested`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateOutlierAboveOriginal(body: any) {
    return this.http.post(`${this.environment.outlierManager}/updateoutlieraboveoriginal`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }


  UpdateOutlierBelowOriginal(body: any) {
    return this.http.post(`${this.environment.outlierManager}/updateoutlierbeloworiginal`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetAccountList() {
    return this.http.get(`${this.environment.outlierManager}/getaccountslist`)
      .pipe(map((accountList: any) => {
        return accountList;
      }));
  }

  GetBrandList() {
    return this.http.get(`${this.environment.outlierManager}/getbrandslist`)
      .pipe(map((brandList: any) => {
        return brandList;
      }));
  }

  GetProductGroupList() {
    return this.http.get(`${this.environment.outlierManager}/getproductgrouplist`)
      .pipe(map((productgrouplist: any) => {
        return productgrouplist;
      }));
  }

  GetProductDescriptionList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetProductDescriptionList`)
      .pipe(map(productdescriptionlist => {
        return productdescriptionlist;
      }));
  }

  GetSKUList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetSKUList`)
    .pipe(map(skulist => {
      return skulist;
    }));
  }

  GetEarliestUnadjustedWeekUpdatedValues() {
    return this.http.get(`${this.environment.outlierManager}/getearliestunadjustedweekupdatedvalues`)
      .pipe(map((updatedValuesList: any) => {
        return updatedValuesList;
      }));
  }

}
